import { createDCHook, collapseDataFromCall } from '../client';
import { getWarmthProfile } from '../services/WarmthProfilePublicService';

export const useWarmthProfilePublicGetWarmthProfile = createDCHook(
  'getWarmthProfile',
  collapseDataFromCall(getWarmthProfile),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
